import { api } from "../../../utility/apiClient";

const BASE = "/api/v1/policies";

/** GET /api/v1/policies?page&limit&status&policy_key&is_current */
export const getPolicies = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.set(k, v);
  });
  const qs = q.toString();
  return api.get(`${BASE}${qs ? `?${qs}` : ""}`);
};

/** GET /api/v1/policies/:id */
export const getPolicyById = (id) => api.get(`${BASE}/${id}`);

/** POST /api/v1/policies */
export const createPolicy = (data) => api.post(BASE, data);

/** PUT /api/v1/policies/:id */
export const updatePolicy = (id, data) => api.put(`${BASE}/${id}`, data);

/** DELETE /api/v1/policies/:id */
export const deletePolicy = (id) => api.delete(`${BASE}/${id}`);
